/// <reference path="LayoutDesignerAdmin.js"/>
(function () {
    var DEL = 46;
	var BACKSPACE = 8;
	var ESC = 27;
    var C = 67;
    var V = 86;
    var X = 88;
    var Z = 90;
    var S = 83;
    var D = 68;
    var pressedKey = false;

    $('body')
    .keydown(function (evt) {
        var isKeyboardCtrl = (evt.ctrlKey || evt.metaKey ? true : false);
        var isShiftKey = event.shiftKey;
        var elementsSelector = '.ui-selected, .ui-group-selected, .layoutElementAdminPendingCopy, .layoutElementAdminPendingCut';
        var isChartCreator = window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART;
        var isReportEditorActive = evt.target.nodeName === "VIS-RE";

        // ignore events caused by the same key repeats
        if (pressedKey === evt.keyCode) return;
        else pressedKey = evt.keyCode;

        if (isReportEditorActive) return;

        if ($(elementsSelector, $('#layoutArea')).length > 0) {
            switch (evt.which) {
                case DEL:
                case BACKSPACE:
                    // DEL or BACKSPACE hit - content box
                    if ($(".DUI-WINDOW-2:not(#singleObjectSetupPanel):visible").length == 0 && !$(":focus").is("textarea") && !$(":focus").is("input")) {						
                        Storyboard.LayoutDesigner.deleteHandler(evt);                        
                    }
                    break;
                case X:
                    // CTRL + X - Cut selected boxes
                    if (isKeyboardCtrl) {
                        Storyboard.LayoutDesigner.cutHandler(evt);
                        isKeyboardCtrl = false;
                    }
                    break;
                case C:
                    // CTRL + C - Copy selected boxes
                    if (isKeyboardCtrl) {
                        Storyboard.LayoutDesigner.copyHandler(evt);
                        isKeyboardCtrl = false;
                    }
                    break;
                case V:
                    // CTRL + V - Paste copied boxes
                    if (isKeyboardCtrl) {
                        Storyboard.LayoutDesigner.pasteHandler(evt);
                        isKeyboardCtrl = false;
                    }
                    break;
                case Z:
                    // CTRL + Z - Undo element move/resize
                    if (isKeyboardCtrl) {
                        Storyboard.LayoutDesigner.history.back();
                        isKeyboardCtrl = false;
                    }
                    break;
                case D:
                    if (isKeyboardCtrl) {
                        Storyboard.LayoutDesigner.duplicateHandler(evt);
                        isKeyboardCtrl = false;
                        evt.preventDefault();
                        evt.stopPropagation();
                    }
                    break;
            }
        }

         if (isChartCreator) {
             if (isKeyboardCtrl && evt.which === S) {
                if (isShiftKey) {
                    ChartCreatorSetup.saveDeckAs();
                } else {
                    ChartCreatorSetup.saveDeck();
                }
                event.preventDefault();
            }
         }

        if (evt.keyCode === 17 || evt.keyCode === 91) {
            $('.layoutElementAdmin.ui-hover', $('#layoutArea')).each(function () {
                $(this).children('.DUI-ST-EL-DIMENSION').remove();
                $(this).children('.DUIToolbar').css('display', 'none');
            });
		}

		if (window.IsDrilldown && evt.keyCode == ESC) {
			var dIframe = $('#' + window.frameElement.id, parent.document);
			var dWindowBody = dIframe.parent();
			var dWindow = dWindowBody.parent();
			$('.DUI-WINDOW-CLOSE', dWindow).click();
		}
    })
    .keyup(function (evt) {
        pressedKey = false;

        if (evt.keyCode === 17 || evt.keyCode === 91) {
            $('.layoutElementAdmin.ui-hover', $('#layoutArea')).each(function() {
                var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid($(this).attr('guid'));
                if (!layoutElement.groupId || layoutElement.sizePositionUnlocked)
                    Storyboard.GuiEvents.updateElementCoordsAndSizes($(this), null);
                $(this).children('.DUIToolbar').css('display', '');
            });
        }
    });

})();
